import { NavLink } from 'react-router-dom';

// Número en formato internacional sin espacios ni "+", como lo pide el enlace
// de WhatsApp Click to Chat.
const WHATSAPP_NUMBER = '523223481679';
const WHATSAPP_MESSAGE = 'Hola, me gustaría más información sobre sus servicios.';
const whatsappUrl = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(WHATSAPP_MESSAGE)}`;

/**
 * Ícono de chat dibujado a mano: evita reproducir el logotipo registrado de
 * WhatsApp y en su lugar usa su verde de marca para que siga siendo
 * reconocible.
 */
const ChatIcon = () => (
  <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" focusable="false">
    <path
      fill="currentColor"
      d="M12 2a10 10 0 0 0-8.6 15.1L2 22l5.1-1.3A10 10 0 1 0 12 2Zm0 18a8 8 0 0 1-4.2-1.2l-.3-.2-3 .8.8-2.9-.2-.3A8 8 0 1 1 12 20Zm4.4-5.6c-.2-.1-1.4-.7-1.7-.8-.2-.1-.4-.1-.6.1-.2.2-.6.8-.8 1-.1.2-.3.2-.5.1-.2-.1-1-.4-1.9-1.2-.7-.6-1.2-1.4-1.3-1.6-.1-.2 0-.4.1-.5l.4-.4c.1-.1.2-.3.2-.4.1-.2 0-.3 0-.5l-.7-1.7c-.2-.4-.4-.4-.6-.4h-.5c-.2 0-.5.1-.7.3-.2.2-.9.9-.9 2.2s1 2.6 1.1 2.7c.1.2 1.9 3 4.7 4.1.7.3 1.2.4 1.6.6.7.2 1.3.2 1.8.1.5-.1 1.4-.6 1.6-1.1.2-.5.2-1 .1-1.1-.1-.1-.2-.2-.4-.3Z"
    />
  </svg>
);

/**
 * Franja azul del home que invita a escribirnos.
 *
 * El botón de WhatsApp abre un chat directo (wa.me) en vez de mandar al
 * formulario, para quien prefiere resolver algo rápido por chat.
 */
const ContactBanner = () => (
  <div className="contactBanner">
    <div>
      <h4>¡Trabajemos juntos! Contáctanos</h4>
      <p className="textContent">
        Conversemos sobre tus estrategias y retos tecnológicos. Llena el formulario y cuéntanos más
        de ti; en breve te contaremos mucho de nosotros.
      </p>
    </div>
    <div className="contactBannerActions">
      <NavLink to="/contact" className="btnYellow">
        Contáctanos
      </NavLink>
      <a
        href={whatsappUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="btnWhatsapp"
        aria-label="Chatear por WhatsApp con Axioma Network"
      >
        <ChatIcon />
        WhatsApp
      </a>
    </div>
  </div>
);

export default ContactBanner;
